import { Box, Radio, useTheme } from "@mui/material";
import React, { useState } from "react";
import samanLogo from "../../../../../../media/images/icons/saman-logo.svg";

interface Props {
  checked: boolean;
}

export default function GatewayItem(props: Props) {
  const theme = useTheme();

  const [checked] = useState(props.checked);
  return (
    <Box
      // onClick={() => setChecked((prev) => !prev)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "4px",
      }}
    >
      <Box
        sx={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.primary[50],
          borderRadius: "8px",
          paddingX: "3px",
          paddingY: "0px",
        }}
      >
        <Radio checked={checked} size="small" />
        <img width={70} src={samanLogo} alt="" />
      </Box>
    </Box>
  );
}
